export default {
    voltar: 'Voltar',
    listagem: 'Listagem',
    integracoes: {
        atributos: 'Atributos',
        credenciais: 'Credenciais',
        cloud_functions: 'CloudFunctions',
        configuracao_protocolo: 'Configuracao de Protocolo',
        estados: 'Estados',
        fabricante: 'Fabricante',
        formatos_arquivos: 'Formatos de Arquivos',
        integration_helper: 'Classes Helpers',
        label: 'Integrações',
        protocolos: 'Protocolos',
        resultados_descartaveis: 'Resultados Descartáveis',
        resultados_controle_descartaveis: 'Recipientes de Controle',
        resultados_editaveis: 'Resultados Editáveis',
    },
    triggers: 'Triggers',
    dexpara:{
        label: 'De X Para',
        ordem: 'Exames de Ordens',
        resultado: 'Exames de Resultados',
        materiais: 'Materiais',
        complements: 'Complementos',
        metodos: 'Métodos',
        exame_resultado: 'Valor de Resultado',
        tipo: 'Por tipo',
        tipo_create: 'Cadastrar tipo',
        result_range_create: 'Faixa de Resultado',
        result_conversion_create: 'Conversão de Resultado'
    },
    equipamentos: {
        label: 'Equipamentos',
        ranges: 'Ranges',
        criar_range: 'Criar range',
        permissoes: 'Permissões'
    },
    monitores: {
        label: 'Monitores',
        tipo: 'VNS por tipo',
        fila_atendimento: 'Fila de Atendimento',
        lista: 'Monitorar lista',
        ordem_resultado: 'Ordem / Resultado',
        ordem_resultado_apoio: 'Ordem / Resultado - Apoio',
        ordem_resultado_lis: 'Ordem / Resultado - Lis',
        etiquetas_apoio: 'Etiquetas Apoio',
        revisar_resultado: 'Revisar Resultado'
    },
    tuevs: {
        label: 'TUEVS',
        dashboard: 'Dashboard',
        importar_exames_clientes_cadastrados: 'Importar Exames de Clientes',
        componentes: 'Componentes',
        exames: 'Exames',
        materiais: 'Materiais',
        complements: 'Complementos',
        metodos: 'Métodos',
        escalas: 'Escalas',
        tempos: 'Tempos',
        examresult: 'Valor de Resultado',
    },
    loinc: {
        label: 'LOINC',
        listagem: 'Listagem',
        importar_csv: 'Importar CSV',
        importar_traducoes: 'Importar CSV de Traduções'
    },
    rnds: {
        listar: 'Listar Transmissões',
        transmitir: 'Transmitir Resultado(s)'
    },
    interopera: {
        transmitir: 'Transmitir Resultado(s)'
    },
    core: {
        label: "Veus Saúde",
        companies: 'Empresas',
        careunits: 'Unidades',
        sector: 'Setor'
    },
    language: {
        select: 'Selecione o Idioma'
    },
    auditoria: {
        label: 'Auditoria',
        logs: 'Logs'
    }
}
